






















































































































import { ChangePasswordVue } from "fs-pb-vue2/vueModels/settings/ChangePasswordVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";

@Component({
  components: { VerifyBox }
})
export default class PasswordEditModal extends ChangePasswordVue {
  async mounted() {
    await this.init();
  }
}
